// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"E3-z","displaySixCardTiles":"F3-z"};